import React, { useMemo } from "react";
import {
  IPayeeEngagementResponse,
  IPayeeResponse,
  PayerPayeeEngagementStatus
} from "@wingspanhq/payments/dist/interfaces";
import {
  WSElementProps,
  WSTable,
  WSTableCell
} from "@wingspanhq/fe-component-library";
import { buildPayeeDetailsEngagementDetailsPath } from "../../utils";
import { useHistory } from "react-router-dom";
import {
  PayerPayeeStatus,
  PaymentsEligibility
} from "@wingspanhq/payments/dist/interfaces/payerPayee";
import { selectorPayerPayeeEngagementName } from "../../selectors/selectorPayerPayeeEngagementName";
import { RequirementStatus } from "@wingspanhq/payments/dist/interfaces/requirement";
import { useXWingspanPayerId } from "./useXWingspanPayerId";
import { useEngagementDefaultActions } from "../../../Engagements/hooks/useEngagementDefaultActions";
import { WSActionsMenuItem } from "@wingspanhq/fe-component-library/dist/lib/components/WSActions/WSActions";

export const EngagementsTable: React.FC<
  {
    payee: IPayeeResponse;
    engagements: IPayeeEngagementResponse[];
  } & WSElementProps
> = ({ payee, engagements, ...elementProps }) => {
  const history = useHistory();
  const getEngagementsActions = useEngagementDefaultActions();
  const xWingspanPayerId = useXWingspanPayerId();

  const tableData = useMemo(() => {
    return engagements.map((engagement, index) => ({
      id: engagement.payerPayeeEngagementId,
      data: engagement
    }));
  }, [engagements]);

  return (
    <>
      <WSTable<IPayeeEngagementResponse>
        tableData={tableData}
        columns={[
          {
            config: {
              header: {
                text: "Name"
              },
              gridTemplateSizeMax: "1fr"
            },
            renderFunction: ({ data }) => {
              return (
                <WSTableCell
                  text={selectorPayerPayeeEngagementName(data, true)}
                />
              );
            }
          },
          // {
          //   config: {
          //     gridTemplateSizeMax: "1fr",
          //     hideOnScreens: ["XS"],
          //     header: {
          //       text: "Type"
          //     }
          //   },
          //   renderFunction: ({ data }) => (
          //     <WSTableCell text={getEngagementLabelByType(data.type)} />
          //   )
          // },
          {
            config: {
              hideOnScreens: ["XS"],
              header: {
                text: "Requirements"
              },
              gridTemplateSizeMax: "1fr"
            },
            renderFunction: ({ data }) => {
              const allLength = data.requirements?.length || 0;

              const completedLength =
                data.requirements?.filter(
                  r => r.status === RequirementStatus.Complete
                )?.length || 0;

              const isComplete = completedLength === allLength && allLength > 0;

              const secondaryText =
                data.paymentsEligibility === PaymentsEligibility.NotEligible
                  ? "Not eligible for payments"
                  : "Eligible for payments";
              const secondaryTextColor =
                data.paymentsEligibility === PaymentsEligibility.NotEligible
                  ? "amber400"
                  : undefined;

              if (data.status === PayerPayeeEngagementStatus.Inactive) {
                return (
                  <WSTableCell
                    pill={{
                      theme: "neutral",
                      text: "Archived",
                      icon: "archive"
                    }}
                  />
                );
              }

              if (allLength === 0) {
                return (
                  <WSTableCell
                    pill={{
                      theme: "neutral",
                      text: "None required",
                      icon: "info-circle"
                    }}
                    secondaryText={secondaryText}
                    secondaryTextColor={secondaryTextColor}
                  />
                );
              }

              return (
                <WSTableCell
                  secondaryText={secondaryText}
                  secondaryTextColor={secondaryTextColor}
                  pill={
                    isComplete
                      ? {
                          theme: "success",
                          text: `${completedLength} of ${allLength} Complete`,
                          icon: true
                        }
                      : {
                          theme: "warning",
                          text: `${completedLength} of ${allLength} Complete`,
                          icon: true
                        }
                  }
                />
              );
            }
          }
          // {
          //   config: {
          //     // gridTemplateSizeMax: "1fr",
          //     header: {
          //       text: "Status"
          //     }
          //   },
          //   renderFunction: ({ data }) => (
          //     <WSTableCell
          //       pill={
          //         data.status === PayerPayeeEngagementStatus.Active
          //           ? {
          //               theme: "success",
          //               text: "Active",
          //               icon: true
          //             }
          //           : {
          //               theme: "neutral",
          //               text: "Inactive",
          //               icon: "archive"
          //             }
          //       }
          //     />
          //   )
          // }
        ]}
        onRowClick={({ data }) => {
          history.push({
            pathname: buildPayeeDetailsEngagementDetailsPath(
              payee.payeeId,
              data.payerPayeeEngagementId
            ),
            search: xWingspanPayerId ? `?payerId=${xWingspanPayerId}` : ""
          });
        }}
        getRowMenuActionsDisabled={({ data }) => {
          return payee.payerOwnedData.status !== PayerPayeeStatus.Active;
        }}
        rowFetchMenuActions={async ({ data }) => {
          const actions: WSActionsMenuItem[] = [];

          if (payee.payerOwnedData.status === PayerPayeeStatus.Active) {
            const defaultActions = await getEngagementsActions({
              payee,
              engagement: data
            });

            return defaultActions;
          }
          return actions;
        }}
        // rowMenuActions={({ data }) => {
        //   const actions: WSMenuItem[] = [];

        //   if (
        //     payee.payeeOwnedData.shareTaxDocument ===
        //       PayeeTaxDocumentSharePermission.Allow &&
        //     isDomesticPayee &&
        //     data.requirementType === GeneralRequirementType.TaxVerification &&
        //     data.status === RequirementStatus.Complete
        //   ) {
        //     actions.push({
        //       onClick: () => {
        //         downloadW9({
        //           // TODO;
        //           collaboratorId: payee.payeeId
        //         });
        //       },
        //       label: "Download PDF",
        //       icon: "download"
        //     });
        //   }

        //   return actions;
        // }}
        {...elementProps}
      />
    </>
  );
};
